import React from "react";
import { useStageTimer } from "@empirica/core/player/classic/react";

export function Break() {
  const timer = useStageTimer();
  const remainingSeconds = Math.ceil((timer?.remaining || 0) / 1000);

  return (
    <div className="h-full flex flex-col items-center justify-center">
      <div className="text-center space-y-8">
        <h2 className="text-3xl font-bold">Short Break</h2>
        <p className="text-xl">
          Take a moment to rest. The second session will begin in {remainingSeconds} seconds.
        </p>
        <p className="text-lg text-gray-600">
          Please take this time to relax and prepare for the next session.
        </p>
      </div>
    </div>
  );
}